<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            ref="gofixTable">
                            <template slot="gofix_table:start_date" slot-scope="row">
                                {{row.item.start_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:end_date" slot-scope="row">
                                {{row.item.end_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:active" slot-scope="row">
                                {{row.item.active ? "Active" : "Inactive"}}
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'user-duty',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['safety_user_duty']));
            return {
                tableConfig:{
                    name: 'safety-user-duty',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "contract_title",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: "contract_title",
                            label: "Project Name",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "user_name",
                            label: "Name",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "role_name",
                            label: "Role",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "property_name",
                            label: "Property",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "service_category_name",
                            label: "Service Category",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "start_date",
                            label: "Start Date",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "end_date",
                            label: "End Date",
                            thStyle: "width:250px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: "active",
                            label: "Status",
                            thStyle: "width:150px",
                            isActive: true,
                            isFilter: false,
                            sorting: false,
                        }
                    ]
                },
                tableItems: [],
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(!this.ClientContractID || !this.ClientContractID.id){
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    resolve({items: [], total: 0});
                    return
                }
                await this.$store.dispatch("UserDutyController/getUserDutiesForSafety", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
        }
    }
</script>